import React from 'react';
import Collapsible from 'react-collapsible';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { Box, Flex, HStack, Icon, Spinner, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import radii from '../../styles/theme/foundation/radii';

const AccordionItem = ({ title, isOpen, toggle, icons, children, isFetching = false, ...rest }) => (
  <Box layerStyle="accordion" {...rest}>
    <Flex
      _focus={{ outline: 'none', boxShadow: 'none' }}
      alignItems="center"
      as="button"
      bg="primaryScale.600"
      borderRadius={isOpen ? `${radii.md} ${radii.md} 0 0` : 'md'}
      color="white"
      height="48px"
      padding={4}
      position="relative"
      textStyle="bodyMd600"
      width="100%"
    >

      <HStack alignItems="center" flex="1" justifyContent="flex-start" onClick={() => toggle(!isOpen)}>
        <Box>
          {title}
        </Box>
        <Icon _hover={{ cursor: 'pointer' }} as={isOpen ? BsChevronUp : BsChevronDown} />
        <Box>
          {isFetching && (
          <HStack ml={2}>
            <Text textStyle="bodySm500">Fetching...</Text>
            <Spinner size="xs" />
          </HStack>
          )}
        </Box>
      </HStack>
      <Box>
        {icons}
      </Box>
    </Flex>
    <Collapsible open={isOpen} overflowWhenOpen="auto">
      {children}
    </Collapsible>
  </Box>
);

AccordionItem.propTypes = {
  /** Accordion title */
  title: PropTypes.string.isRequired,
  /** Controlled by toggle function */
  isOpen: PropTypes.bool.isRequired,
  /** Toggle function to open and close accordion */
  toggle: PropTypes.func.isRequired,
  /** Element that will toggle between visible and hidden */
  children: PropTypes.element.isRequired,
  /** Optional icon menu */
  icons: PropTypes.element,
  /** Flag to show loading spinner on data fetch */
  isFetching: PropTypes.bool
};

export default AccordionItem;
